import React, { useState, Fragment, useEffect } from "react";
import { createChatSocket } from "../../utils/chatSocket";

///////////// socket.io //////////////
const socket = createChatSocket();
///////////// socket.io //////////////

export const Mapcontainer = (props) => {
  let thisContainerHeight = window.innerHeight - 70;  // 65 is the height of the navbar
  const [height, setHeight] = useState(thisContainerHeight);
  // const [viewtool, setViewtool] = useState(false);


  ////////////////////////////////////// socket.io ///////////////////////////////////////
  // useEffect(() => {
  //   console.log("socket.on useEffect")
  //   socket.on("stsync", (data) => {  // 소켓서버에서 보낸 자료를 받음
  //     const { name, msg, time } = data;
  //     console.log(+new Date()+" : "+name+" : "+msg+" : "+time);
  //     // const { name, msg, time } = data;
  //     // const item = new LiModel(name, msg, time);
  //     // item.makeLi();
  //     alert(+new Date()+" : "+name+" : "+msg+" : "+time );
  //   });
  // }, []);

  const callgetLoccation = () => {  // 소캣서버로  자료를 보냄
    const text = `동원자원의 위치정보를 갱신합니다. 모든 동원자원에 갱신요청을 보내서 응답온 자원만 갱신되어 표시되며 5초후 지도에 적용됩니다. 동원자원앱이 종료되어 있거나 위치정보제공을 거부한 경우는 정보를 보내지 않습니다. \n\n위치정보를 갱신하시겠습니까? `
    if(window.confirm(text) == false) return;
    const param = {
      sort: "getlocation",
      dsid: sessionStorage.ondsid.trim(),
    };
    console.log(param);
    socket.emit("getlocaiton", param);

    setTimeout(() => { // 5초후 지도에 적용
      props.refreshloc()
    }, 5000);
    timeron();

  };
  ////////////////////////////////////// socket.io ///////////////////////////////////////

  window.addEventListener("resize", () => {
    thisContainerHeight = window.innerHeight - 70;
    setHeight(thisContainerHeight);
  });

  const changemaptypeHandler = (type) => {
    if (type === "roadmap") props.maptype("roadmap");
    if (type === "hybrid") props.maptype("hybrid");
  };

  useEffect(() => {
    const onMapRefresh = () => callgetLoccation();
    const onMapType = (e) => changemaptypeHandler(e.detail);
    window.addEventListener("mapRefresh", onMapRefresh);
    window.addEventListener("mapType", onMapType);
    return () => {
      window.removeEventListener("mapRefresh", onMapRefresh);
      window.removeEventListener("mapType", onMapType);
    };
  }, [props.refreshloc, props.maptype]);

  const timeron = () => {
    const timer = document.createElement("span");
    timer.id = "timer";
    timer.className = "timer";
    const body = document.querySelector("body");
    body.appendChild(timer);
    timer.innerHTML = "5";
    // 5초동안 1초마다 1씩 감소하는 타이머
    const interval = setInterval(() => {
      timer.innerHTML = timer.innerHTML - 1;
    }, 1000);
    // 5초 후 타이머 제거
    setTimeout(() => {
      clearInterval(interval);
      timer.remove();
    }, 5000); 
  }

  return (
    <Fragment>    
      
      <div id="map" className="map" style={{height:height}} />
    </Fragment>
  );
};
